var _path, _path2, _path3, _path4, _circle, _path5, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderMedicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3C2 1.89543 2.89543 1 4 1H11C12.1046 1 13 1.89543 13 3V5H2V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H10V8H5V5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2399 22.5H2.76007C2.00091 22.5 1.5 21.9729 1.5 21.4551V2.54488C1.5 2.02708 2.00091 1.5 2.76007 1.5H13.2399C13.9991 1.5 14.5 2.02708 14.5 2.54488V21.4551C14.5 21.9729 13.9991 22.5 13.2399 22.5Z",
    fill: "white",
    stroke: "#797979"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1325 4H5.86748C5.54128 4 5.23955 3.74779 5.05199 3.32301L4 1H12L10.948 3.32301C10.7523 3.74779 10.4506 4 10.1325 4Z",
    fill: "#797979"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 7,
    fill: "#E57200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12V15H12C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17H15V20C15 20.5523 15.4477 21 16 21C16.5523 21 17 20.5523 17 20V17H20C20.5523 17 21 16.5523 21 16C21 15.4477 20.5523 15 20 15H17V12Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 20,
    r: 1,
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderMedicationIcon);
export default __webpack_public_path__ + "static/media/OrderMedicationIcon.0c2020466a864dbe2ed5cba6c88fd219.svg";
export { ForwardRef as ReactComponent };